export interface FilterGroup {
  key: "genre" | "region" | "year";
  label: string;
  options: string[];
}

export const genres: string[] = ["爱情", "剧情", "动作", "喜剧", "悬疑", "科幻", "青春", "文艺", "犯罪", "动画", "奇幻", "家庭", "冒险", "惊悚"];

export const regions: string[] = ["大陆", "港台", "欧美", "日韩"];

export const years: string[] = ["2024", "2023", "2022", "2021", "2020年及以前"];

export const filterGroups: FilterGroup[] = [
  { key: "genre", label: "类型", options: genres },
  { key: "region", label: "地区", options: regions },
  { key: "year", label: "年份", options: years },
];

export interface HomeCategory {
  name: string;
  icon: string;
  desc: string;
}

export const homeCategories: HomeCategory[] = [
  { name: "爱情", icon: "ri-heart-3-line", desc: "怦然心动的浪漫故事" },
  { name: "剧情", icon: "ri-book-open-line", desc: "细腻深刻的人间百态" },
  { name: "动作", icon: "ri-flashlight-line", desc: "酣畅淋漓的视听盛宴" },
  { name: "喜剧", icon: "ri-emotion-happy-line", desc: "轻松解压的欢乐时光" },
  { name: "悬疑", icon: "ri-search-eye-line", desc: "烧脑反转的推理迷局" },
  { name: "科幻", icon: "ri-planet-line", desc: "脑洞大开的未来世界" },
  { name: "文艺", icon: "ri-moon-clear-line", desc: "诗意的光影与呼吸" },
  { name: "动画", icon: "ri-palette-line", desc: "献给想象力的礼物" },
];